<template>
  <div id="app">
    <NavBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: { NavBar, Footer }
}
</script>

<style lang="scss">
/* 修复横向溢出 */
html,
body {
  max-width: 100%;
  overflow-x: hidden;
  /* 禁止横向滚动 */
  margin: 0;
  padding: 0;
}

/* 统一盒模型，防止 padding 撑大 width:100% */
*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  width: 100%;
  overflow-x: hidden;
}
</style>
